(function () {
  'use strict';

  function openDrawer() {
    if (
      window.T4SThemeSP &&
      window.T4SThemeSP.Drawer &&
      window.jQuery_T4NT
    ) {
      window.T4SThemeSP.Drawer.opend(
        window.jQuery_T4NT('#t4s-mini_cart')
      );
    }
  }

  function refreshAndOpen() {
    if (!window.T4SThemeSP || !window.T4SThemeSP.Cart) {
      setTimeout(refreshAndOpen, 100);
      return;
    }

    var opened = false;

    function done() {
      if (opened) return;
      opened = true;
      document.removeEventListener('cart:updated', done);
      openDrawer();
    }

    document.addEventListener('cart:updated', done);
    window.T4SThemeSP.Cart.getToFetch(false);
    setTimeout(done, 3000);
  }

  window.PalloroCartDrawer = {
    refreshAndOpen: refreshAndOpen
  };

  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      '.t4s-site-nav__cart > a[data-drawer-options*="#t4s-mini_cart"]'
    );

    if (!link) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    refreshAndOpen();
  }, true);
})();
